import { motion } from 'framer-motion'
import { Package, Palette, Shirt, Sparkles } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const FLOATING_ICONS = [
  {
    Icon: Shirt,
    gradient: 'from-violet-400 to-purple-600',
    delay: 0,
  },
  {
    Icon: Palette,
    gradient: 'from-sky-400 to-blue-500',
    delay: 0.2,
  },
  {
    Icon: Package,
    gradient: 'from-fuchsia-400 to-pink-500',
    delay: 0.4,
  },
] as const

export const CanvasEmptyIllustration = () => {
  const { t } = useLocalization()

  return (
    <Column className="items-center gap-5">
      <Row className="items-end justify-center gap-4">
        {FLOATING_ICONS.map(({ Icon, gradient, delay }, index) => (
          <motion.div
            key={gradient}
            className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br shadow-lg ${gradient}`}
            style={{
              marginBottom: index === 1 ? 12 : 0,
            }}
            initial={{ opacity: 0, y: 16, scale: 0.8 }}
            animate={{
              opacity: 1,
              y: [0, -5, 0],
              scale: 1,
            }}
            transition={{
              opacity: { duration: 0.5, delay },
              scale: { type: 'spring', stiffness: 260, damping: 20, delay },
              y: {
                duration: 3.2,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: delay + 0.5,
              },
            }}
          >
            <Icon className="h-5 w-5 text-white" strokeWidth={1.75} />
          </motion.div>
        ))}
      </Row>

      <motion.div
        className="relative w-full overflow-hidden rounded-3xl border border-white/70 bg-white/75 px-8 py-7 shadow-[0_20px_60px_-12px_rgba(99,102,241,0.18)] backdrop-blur-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.15, ease: 'easeOut' }}
      >
        <div
          className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-violet-300/30 blur-2xl"
          aria-hidden
        />
        <div
          className="pointer-events-none absolute -bottom-8 -left-8 h-28 w-28 rounded-full bg-sky-300/25 blur-2xl"
          aria-hidden
        />

        <Column className="relative items-center gap-2 text-center">
          <Row className="items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-violet-500 to-indigo-600 shadow-sm">
              <Sparkles className="h-3.5 w-3.5 text-white" strokeWidth={2} />
            </div>
            <h3>
              {t('Your canvas is ready', 'Din canvas är redo')}
            </h3>
          </Row>
          <p className="max-w-[280px] text-sm text-muted-foreground">
            {t(
              'Add products from the catalog, drop files here, paste links, or tag @Sara in the chat.',
              'Lägg till produkter från katalogen, släpp filer här, klistra in länkar eller tagga @Sara i chatten.'
            )}
          </p>
        </Column>
      </motion.div>
    </Column>
  )
}
